module.exports = __webpack_public_path__ + "img/eagle.fb9c1f5b.png";